import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Podcast from "./pages/Podcast";
import Speaking from "./pages/Speaking";
import Consulting from "./pages/Consulting";
import YouthMentorship from "./pages/YouthMentorship";
import YouthMentorshipGuidance from "./pages/YouthMentorshipGuidance";
import MathStemTutoring from "./pages/MathStemTutoring";
import CareerCounselling from "./pages/CareerCounselling";
import Books from "./pages/Books";
import Contact from "./pages/Contact";
import Apply from "./pages/Apply";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/podcast" element={<Podcast />} />
          <Route path="/speaking" element={<Speaking />} />
          <Route path="/consulting" element={<Consulting />} />
          <Route path="/consulting/youth-mentorship" element={<YouthMentorship />} />
          <Route path="/consulting/youth-mentorship-guidance" element={<YouthMentorshipGuidance />} />
          <Route path="/consulting/math-stem-tutoring" element={<MathStemTutoring />} />
          <Route path="/consulting/career-counselling" element={<CareerCounselling />} />
          <Route path="/books" element={<Books />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
